<!-- Loading -->
@if ((loadingService.loading$ | async)) {
  <div class="overlay">
    @if ((loadingService.loading$ | async)) {
      <p-progressSpinner ariaLabel="loading" class="loading-spinner" />
    }
  </div>
}
<div class="container">
  <router-outlet></router-outlet>
</div>